module.exports = __webpack_public_path__ + "static/hero-workout-img-7bce79d31f9410b9fd5169a976689d51.png";